import { render, staticRenderFns } from "./Notifications.vue?vue&type=template&id=67638f4f&"
import script from "./Notifications.vue?vue&type=script&lang=js&"
export * from "./Notifications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\xampp\\htdocs\\invoicingfullversion2\\invoicing_app\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67638f4f')) {
      api.createRecord('67638f4f', component.options)
    } else {
      api.reload('67638f4f', component.options)
    }
    module.hot.accept("./Notifications.vue?vue&type=template&id=67638f4f&", function () {
      api.rerender('67638f4f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/settings/Notifications.vue"
export default component.exports